module.exports = __webpack_public_path__ + "img/two-fa-background.d73831e8.png";